// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"95":"ff3a2156","116":"d8006e61","157":"6b8c5b11","245":"712e171d","331":"f46814e3","428":"129dd596","430":"b0eb3481","790":"b13640e6","916":"27b05a5f","926":"613fedd7","967":"adae5000"}[chunkId] + ".js";
};